<template>
  <div class="booking mb-15">
    <v-divider></v-divider>
    <v-text-field v-model='par' v-if="0"></v-text-field>
    <v-expansion-panels class="my-3" v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header color="green lighten-5">
          <h5>{{ $t("booking.make_a_booking.expansion") }}</h5>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!--v-row>
            <v-col cols="12" xs="12" class="mt-3">
              <v-select v-if="$i18n.locale=='tc'"
                :items="api.experiments"
                item-text="experiment_set_chi"
                item-value="experiment_set"
                v-model="selected_experiment"
                label="請選擇實驗組"
                no-data-text="沒有適用的實驗組"
                @change="changeExperimentSet(selected_experiment);"
                outlined
              ></v-select>
              <v-select v-else
                :items="api.experiments"
                item-text="experiment_set"
                item-value="experiment_set"
                v-model="selected_experiment"
                label="Select an experiment set"
                no-data-text="No Experiment Available"
                @change="changeExperimentSet(selected_experiment);"
                outlined
              ></v-select>
            </v-col>
            <v-col class="py-0 pl-6 mt-n5" cols="12">
              <v-checkbox v-if="$i18n.locale=='tc' && authorized"
                class="m-0"
                v-model="show_all"
                label="顯示所有實驗組"
                @change="getSchoolOpenedExperiment();"
              ></v-checkbox>
              <v-checkbox v-else-if="authorized"
                class="m-0"
                v-model="show_all"
                label="Show All Experiment Sets"
                @change="getSchoolOpenedExperiment();"
              ></v-checkbox>
            </v-col>
          </v-row-->
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" lg="4" class="my-2 ">
              <v-date-picker v-if="$i18n.locale=='tc'"
                locale="zh-tw"
                ref="picker"
                v-model="current_date"
                full-width
                color="primary"
                @change="getSlotsByDate();getExperimentSetStatus();"
              ></v-date-picker>
              <v-date-picker v-else
                locale="en"
                ref="picker"
                v-model="current_date"
                full-width
                color="primary"
                @change="getSlotsByDate();getExperimentSetStatus();"
              ></v-date-picker>
              <hr>
            </v-col>
            <v-col cols="12" xs="12" sm="6" md="6" lg="8" class="my-2 px-1">
              <v-col cols="12" xs="12" class="px-0">
                <v-select v-if="$i18n.locale=='tc'"
                  :items="api.experiments"
                  item-text="experiment_set_chi"
                  item-value="experiment_set"
                  v-model="selected_experiment"
                  label="-- 按此選擇實驗組 --"
                  no-data-text="沒有適用的實驗組"
                  @change="changeExperimentSet(selected_experiment);"
                  outlined
                  :class="{select_experiment: selectExperiment()}"
                ></v-select>
                <v-select v-else
                  :items="api.experiments"
                  item-text="experiment_set"
                  item-value="experiment_set"
                  v-model="selected_experiment"
                  label="-- Click here to select experiment set --"
                  no-data-text="No Experiment Available"
                  @change="changeExperimentSet(selected_experiment);"
                  outlined
                  background-color="rgba(255,255,255,0.3)"
                  :class="{select_experiment: selectExperiment()}"
                ></v-select>
              </v-col>
              <v-col class="py-0 pl-0 mt-n7" cols="12">
                <v-checkbox v-if="$i18n.locale=='tc' && authorized"
                  class="m-0"
                  v-model="show_all"
                  label="顯示所有實驗組"
                  @change="getSchoolOpenedExperiment();"
                ></v-checkbox>
                <v-checkbox v-else-if="authorized"
                  class="m-0"
                  v-model="show_all"
                  label="Show All Experiment Sets"
                  @change="getSchoolOpenedExperiment();"
                ></v-checkbox>
              </v-col>
              <small v-if="$i18n.locale=='tc'">{{ max_text_chi }}</small>
              <small v-else >{{ max_text }}</small>
              <div class="title">{{ api.experiment_name }}</div>
              <!-- <div class="subheading">{{current_date}}</div> -->
              <v-alert v-if="api.eStatus=='HOLD'" border="left" color="red lighten-1" dark>
                <v-icon class="pr-3">mdi-alert</v-icon>{{ $t("booking.make_a_booking.alert_hold") }}
              </v-alert>
              <v-data-table
                :headers="tableHeader('slots')"
                :items="api.slots"
                :sort-by="['passed']"
                hide-default-footer
                :items-per-page="-1"
                :footer-props="{
                    itemsPerPageOptions: [-1],
                }"
              >
                <template v-slot:body="{ items }">
                    <tbody>
                    <!-- :class="{active:isPassed(slot)}" -->
                    <tr v-for="(slot, index) in items" :key="index" :class="{passed: isPassed(slot), override:isOverrided(slot), my_booking:isMyBooking(slot)}" >
                      <template v-if="slot.display">
                        <!-- <td><p v-if="index==0 || api.slots[index-1].start_at!=api.slots[index].start_at">{{ slot.start_at | moment("HH:mm") }}</p></td>
                                  <td><p v-if="index==0 || api.slots[index-1].end_at!=api.slots[index].end_at">{{ slot.end_at | moment("HH:mm") }}</p></td> -->
                        <td>
                          <p>{{ slot.start_at | moment("HH:mm") }}</p>
                        </td>
                        <td>
                          <p>{{ slot.end_at | moment("HH:mm") }}</p>
                        </td>
                        <td>
                          <!--p v-if="!isPassed(slot)">{{ slot.status }}</p>
                          <p v-else></p-->
                          <p v-if="$i18n.locale=='tc'">{{ slot.status_chi }}</p>
                          <p v-else>{{ slot.status }}</p>
                        </td>
                        <td v-if="authorized">
                          <template>
                            <v-btn 
                              v-if='slot.username!="" && slot.username!=null && slot.username!=undefined' 
                              class='btn' 
                              outlined 
                              small 
                              @click='openDailyBookingDialog(slot.username)'
                            >
                              {{ slot.username }}
                            </v-btn>
                          </template>
                        </td>
                        <td>
                          <template v-if="slot.has_entered=='Y'">
                            {{ slot.has_entered }}
                          </template>

                        </td>
                        <td>
                          <template v-if=" !(isPassed(slot)  || slot.status=='UNAVAILABLE' ) " >
                            <v-btn
                              color="amber darken-2 white--text"
                              v-if="isBookedSoon(slot)"
                              @click="releaseSlot(slot.id)"
                              rounded
                              >{{ $t("booking.btn.cancel") }}
                            </v-btn>
                            <template v-if="isBookedByMe(slot)">
                              <v-icon v-if="slot.current=='1'&&(api.eStatus=='HOLD' || slot.status=='SUSPENDED')" color="red" >mdi-alert-circle</v-icon>
                              <v-btn
                                color="primary"
                                @click="enterLab(slot.id, slot.experiment, slot.equipment_id, 'player', slot.override, current.user_level)"
                                :disabled="slot.status=='SUSPENDED' || slot.eStatus=='HOLD'"
                              >
                                {{ $t("booking.btn.enter_lab") }}
                              </v-btn>
                            </template>
                            
                            <template v-if="slot.status == 'AVAILABLE'">
                              <v-icon v-if="api.eStatus=='HOLD'" color="red" >mdi-alert-circle</v-icon>
                              <v-btn
                                color="accent"
                                v-if="slot.status == 'AVAILABLE'"
                                @click="bookSlot(slot.id)"
                                rounded
                                :disabled="slot.eStatus == 'HOLD'"
                                >{{ $t("booking.btn.book") }}</v-btn
                              >
                            </template>

                          </template>
                        </td>
                        <td v-if="authorized">
                          <template v-if=" !(isPassed(slot)) " >
                            <v-tooltip  v-if='(slot.status=="SUSPENDED" || slot.status=="UNAVAILABLE") && slot.status!="MAINTENANCE"' top color="green">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" @click="openUnlockBookingDialog(slot)">
                                  <v-icon small color="green"> mdi-lock-open-variant </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("booking.btn.tooltip.unlock") }}</span>
                            </v-tooltip>
                            <v-tooltip v-if='slot.status!="SUSPENDED" && slot.status!="UNAVAILABLE" && slot.status!="MAINTENANCE"' top color="grey">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" @click="openLockBookingDialog(slot)">
                                  <v-icon small color="grey"> mdi-lock-outline </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("booking.btn.tooltip.lock") }}</span>
                            </v-tooltip>
                            <v-tooltip v-if='slot.status=="MAINTENANCE"' top color="green darken-2">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" @click="openUnsetMaintenanceDialog(slot)">
                                  <v-icon small color="green darken-2"> mdi-cog-off </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("booking.btn.tooltip.unset_maintenance") }}</span>
                            </v-tooltip>
                            <v-tooltip v-if='slot.status!="MAINTENANCE"&&slot.status!="SUSPENDED"&&slot.status!="RESERVED"' top color="amber darken-2">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" @click="openMaintenanceDialog(slot)">
                                  <v-icon small color="amber darken-2"> mdi-wrench </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("booking.btn.tooltip.set_maintenance") }}</span>
                            </v-tooltip>
                            <v-tooltip v-if='slot.status!="CANCELLED"' top color="red lighten-2">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" @click="openCancelBookingDialog(slot)">
                                  <v-icon small color="red lighten-2"> mdi-delete </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("booking.btn.tooltip.remove") }}</span>
                            </v-tooltip>
                            <v-tooltip v-if='slot.status=="CANCELLED"' top color="blue">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" @click="openUndoCancelBookingDialog(slot)">
                                  <v-icon small color="blue"> mdi-arrow-u-left-top-bold </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("booking.btn.tooltip.undo_remove") }}</span>
                            </v-tooltip>
                            <v-tooltip v-if='(current.user_level=="INCHARGE" || current.user_level=="ADMIN") && slot.current==true' top color="blue-grey">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on" @click="enterLab(slot.id, slot.experiment, slot.equipment_id, 'overrider', slot.override, current.user_level)">
                                  <v-icon small class="mr-2" color="blue-grey"> mdi-arrow-right-box </v-icon>                            
                                </v-btn>
                              </template>
                              <span>{{ $t("booking.btn.tooltip.overrider_enter") }}</span>
                            </v-tooltip>
                          </template>
                          <template>
                            <v-tooltip  v-if='(slot.status=="SUSPENDED" || slot.status=="RESERVED" || slot.status=="MAINTENANCE")&&(slot.username!=null && slot.username!=undefined && slot.username!="")' top color="blue">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon v-bind="attrs" v-on="on" @click="openReturnBookingDialog(slot)">
                                <v-icon small color="blue"> mdi-undo-variant </v-icon>
                              </v-btn>
                            </template>
                            <span>{{ $t("booking.btn.tooltip.return") }}</span>
                          </v-tooltip>
                          </template>
                        </td>
                      </template>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>          
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog
      v-model="lockBookingDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_lock") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ lockUnlockBookingItem.id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ lockUnlockBookingItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ lockUnlockBookingItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ lockUnlockBookingItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ lockUnlockBookingItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ lockUnlockBookingItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="lockBookingDialog = false; lockUnlockBookingItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            color="grey darken-2"
            text
            @click="lockBooking(lockUnlockBookingItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="unlockBookingDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_unlock") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ lockUnlockBookingItem.id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ lockUnlockBookingItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ lockUnlockBookingItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ lockUnlockBookingItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ lockUnlockBookingItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ lockUnlockBookingItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-2"
            text
            @click="unlockBookingDialog = false; lockUnlockBookingItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="unlockBooking(lockUnlockBookingItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="maintenanceDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_set_maintenance") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ maintenanceItem.id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ maintenanceItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ maintenanceItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ maintenanceItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ maintenanceItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ maintenanceItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="maintenanceDialog = false; maintenanceItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            color="grey darken-2"
            text
            @click="setMaintenanceBooking(maintenanceItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="unsetMaintenanceDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_unset_maintenance") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ maintenanceItem.id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ maintenanceItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ maintenanceItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ maintenanceItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ maintenanceItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ maintenanceItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-2"
            text
            @click="unsetMaintenanceDialog = false; maintenanceItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="unsetMaintenanceBooking(maintenanceItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="cancelBookingDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_remove") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ cancelBookingItem.id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ cancelBookingItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ cancelBookingItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ cancelBookingItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ cancelBookingItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ cancelBookingItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="cancelBookingDialog = false; cancelBookingItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            color="grey darken-2"
            text
            @click="cancelBooking(cancelBookingItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="undoCancelBookingDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("booking.dialog.header_restore") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ cancelBookingItem.id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ cancelBookingItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ cancelBookingItem.experiment }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.equipment_id") }}</th>
              <td>{{ cancelBookingItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ cancelBookingItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ cancelBookingItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="undoCancelBookingDialog = false; cancelBookingItem = {};"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            color="grey darken-2"
            text
            @click="undoCancelBooking(cancelBookingItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>      
    </v-dialog>
    <v-dialog
      v-model="dailyBookingDialog"
      persistent
      max-width="500"
    >
      <v-card>
          <v-toolbar dark color="green">
          <v-btn icon dark @click="dailyBookingDialog = false; dailyUser = null;">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("booking.dialog.header_daily") }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="body-1">
          <br>
          User: {{ dailyUser }}
          <br>
          Date: {{ current_date | moment("YYYY-MM-DD (ddd)") }}
          <v-divider></v-divider>
          <v-data-table
            :headers="tableHeader('daily_slots')"
            :items="api.daily_slots"
            :sort-by="['start_at']"
            hide-default-footer
            :items-per-page="-1"
            :footer-props="{
                itemsPerPageOptions: [-1],
            }"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <!-- :class="{active:isPassed(slot)}" -->
                <tr v-for="(slot, index) in items" :key="index" :class="{passed: isPassed(slot), override:isOverrided(slot)}" >
                  <template>
                    <td>
                      <p>{{ slot.start_at | moment("HH:mm") }}</p>
                    </td>
                    <td>
                      <p>{{ slot.end_at | moment("HH:mm") }}</p>
                    </td>
                    <td>
                      <p v-if="$i18n.locale=='tc'">{{ slot.status_chi }}</p>
                      <p v-else>{{ slot.status }}</p>
                    </td>
                    <td>
                      <template >
                        <v-tooltip  v-if='slot.status=="SUSPENDED" || slot.status=="RESERVED" || slot.status=="MAINTENANCE"' top color="blue">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" @click="openReturnBookingDialog(slot)">
                              <v-icon small color="blue"> mdi-undo-variant </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t("booking.btn.tooltip.return") }}</span>
                        </v-tooltip>
                      </template>
                    </td>
                  </template>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="returnBookingDialog"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5" >
          {{ $t("booking.dialog.header_return") }}
        </v-card-title>
        <v-card-text>
          <table>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.ref") }}</th>
              <td>{{ returnBookingItem.id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.username") }}</th>
              <td>{{ returnBookingItem.username }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.school") }}</th>
              <td>{{ returnBookingItem.school }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.experiment") }}</th>
              <td>{{ returnBookingItem.experiment }} - {{ returnBookingItem.equipment_id }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.start") }}</th>
              <td>{{ returnBookingItem.start_at }}</td>
            </tr>
            <tr>
              <th class='pr-2'>{{ $t("booking.dialog.end") }}</th>
              <td>{{ returnBookingItem.end_at }}</td>
            </tr>
          </table>
        </v-card-text>          
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="returnBookingDialog = false;"
          >
            {{ $t("booking.dialog.btn_discard") }}
          </v-btn>
          <v-btn
            color="grey darken-2"
            text
            @click="returnBooking(returnBookingItem)"
          >
            {{ $t("booking.dialog.btn_confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import {api_booking} from '@/services/iot/api_booking';
const apiBooking = new api_booking(process.env.VUE_APP_BASE_URL);
import { api_management } from "@/services/iot/api_management";
const apiManagement = new api_management(process.env.VUE_APP_BASE_URL);

export default {
  name: "experiment",
  components: {
  },
  props: {
    par: String,
  },
  mixins: [],
  data: function () {
    return {
      styleObject: {
        color: 'red',
        fontSize: '13px'
      },
      authorized: false,
      current_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, -1).substr(0, 10),
      today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, -1).substr(0, 10),      
      panel: 0,
      school_id: "",
      role: null,
      drawer: true,
      mini: true,      
      dialog: false,
      show_all: false,
      lockUnlockItem: {},
      lockUnlockBookingItem: {},
      maintenanceItem: {},
      cancelBookSlotItem: {},
      cancelBookingItem: {},
      returnBookingItem: {},
      dailyUser: null,
      lockDialog: false,
      unlockDialog: false,
      lockBookingDialog: false,
      unlockBookingDialog: false,
      maintenanceDialog: false,
      unsetMaintenanceDialog:false,
      cancelBookingDialog: false,
      undoCancelBookingDialog: false,
      dailyBookingDialog: false,
      returnBookingDialog: false,
      selected_experiment: "",
      user_group_profile: 0,
      max_text: "",
      max_text_chi: "",
      current:{
        school_id: null,
        username: null,
        user_level: "USER",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      api:{
        schools:[],
        experiments:[{field: "BIOLOGY", experiment: "BACTERIA_GROWTH", experiment_name: "Bacteria Growth", status: "ACTIVE",create_at: "2022-09-06 15:55:17"}],
        experiments_list:[],
        experiment_sets: [],
        book_slots: [],
        slots: [],
        school_id: null,
        school_name: null,
        school_chi_name: null,
        school_logo_url: "",
        eStatus: "",
        daily_slots: [],
      },
      form: {
        school: "",
        experiment: "",
        equipment_id: "",
        date: "",
      },
      headers: [
        { text: 'Passed', value: 'passed', align: ' d-none' },
        { text: 'From', value: 'start_at', sortable: false },
        { text: 'To', value: 'end_at', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Action', value: 'action', sortable: false },
      ],
      headers_chi: [
        { text: '已結束', value: 'passed', align: ' d-none' },
        { text: '開始', value: 'start_at', sortable: false },
        { text: '結束', value: 'end_at', sortable: false },
        { text: '狀態', value: 'status', sortable: false },
        { text: '操作', value: 'action', sortable: false },
      ],
      headers_auth: [
        { text: 'Passed', value: 'passed', align: ' d-none'},
        { text: 'From', value: 'start_at', sortable: false },
        { text: 'To', value: 'end_at', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Username', value: 'status', sortable: false },
        { text: 'Has Entered', value: 'has_entered', sortable: false },
        { text: 'Action', value: 'action', sortable: false },
        { text: 'Authorized Action', value: 'auth_action', sortable: false }, 
      ],
      headers_auth_chi: [
        { text: '已結束', value: 'passed', align: ' d-none'},
        { text: '開始', value: 'start_at', sortable: false },
        { text: '結束', value: 'end_at', sortable: false },
        { text: '狀態', value: 'status', sortable: false },
        { text: '使用者', value: 'status', sortable: false },
        { text: '已進入', value: 'has_entered', sortable: false },
        { text: '操作', value: 'action', sortable: false },
        { text: '授權操作', value: 'auth_action', sortable: false }, 
      ],
      headers_daily: [
        { text: 'Passed', value: 'passed', align: ' d-none'},
        { text: 'From', value: 'start_at', sortable: false },
        { text: 'To', value: 'end_at', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Action', value: 'action', sortable: false },
      ],
      headers_daily_chi: [
        { text: '已結束', value: 'passed', align: ' d-none'},
        { text: '開始', value: 'start_at', sortable: false },
        { text: '結束', value: 'end_at', sortable: false },
        { text: '狀態', value: 'status', sortable: false },
        { text: '操作', value: 'action', sortable: false },
      ],
      headers_book_slots: [
        { text: 'Ref', value: 'ref' },
        { text: 'School', value: 'school' },
        { text: 'Experiment', value: 'experiment' },
        { text: 'Equipment ID', value: 'equipment_id' },
        { text: 'Date', value: 'date' },
        { text: 'Time', value: 'time' },
        { text: 'Duration (mins)', value: 'duration' },
        { text: 'Status', value: 'status' },
        { text: 'Update At', value: 'update_at' },
        { text: 'Actions', value: 'actions', sortable: false },        
      ],
      setTranslate: {
        "set_1": "裝置1",
        "set_2": "裝置2",
        "set_3": "裝置3",
        "set_4": "裝置4",
        "set_5": "裝置5",
        "set_6": "裝置6",
        "set_7": "裝置7",
        "set_8": "裝置8",
        "set_9": "裝置9",
        "裝置1": "set_1",
        "裝置2": "set_2",
        "裝置3": "set_3",
        "裝置4": "set_4",
        "裝置5": "set_5",
        "裝置6": "set_6",
        "裝置7": "set_7",
        "裝置8": "set_9",
      },
      experimentNameTranslate: {
        "apparent_depth": "表觀深度",
        "em_induction": "電磁感應",
        "interference": "干涉現象",
        "photoelectric": "光電效應",
        "ultrasound": "超聲波成像",
        "radiation": "幅射",
        "visible_spectrum": "可見光光譜",
        "emission_spectrum": "發射光譜",
        "titration": "滴定法",
        "identify_unknown_anion": "辨識未知負離子",
        "kinetic_rate": "化學反應速率",
        "spectrophotometry": "分光光度法",
        "bacteria_growth": "細菌生長",
        "greenhouse": "溫室效應",
        "iodine_test": "碘測試",
        "photosynthesis": "光合作用",
        "respiration": "呼吸作用",
        "tensile_test": "拉伸試驗",
        "capacitance": "電容",
        "air_monitoring": "空氣監測",
        "表觀深度": "APPARENT_DEPTH",
        "電磁感應": "EM_INDUCTION",
        "干涉現象": "INTERFERENCE",
        "光電效應": "PHOHOELECTRIC",
        "超聲波成像": "ULTRASOUND",
        "幅射": "RADIATION",
        "可見光光譜": "VISIBLE_SPECTRUM",
        "發射光譜": "EMISSION_SPECTRUM",        
        "滴定法": "TITRATION",
        "辨識未知負離子": "IDENTIFY_UNKNOWN_ANION",
        "化學反應速率": "KINETIC_RATE",
        "分光光度法": "SPECTROPHOTOMETRY",
        "細菌生長": "BACTERIA_GROWTH",
        "溫室效應": "GREENHOUSE",
        "碘測試": "IODINE_TEST",
        "光合作用": "PHOTOSYNTHESIS",
        "呼吸作用": "RESPIRATION",
        "拉伸試驗": "TENSILE_TEST",
        "電容": "CAPACITANCE",
        "空氣監測": "AIR_MONITORING"
      }
    };
  },
  created: function () {
  },
  mounted: function () {    
    var self = this;
    //self.$store.commit("showSnackBar", "Prepareing experiment...");
    
    self.current.school_id = self.$store.state.user.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.school_id = self.$route.params.school_id;
    self.experiment = self.$route.query.experiment;
    self.equipment_id = self.$route.query.equipment;
    if(self.experiment!=undefined && self.equipment_id != undefined){
      if(self.$i18n.locale=='tc'){
        self.selected_experiment = self.experimentNameTranslate[self.experiment] + " - " + self.setTranslate[self.equipment_id];
      }
      else {
        self.selected_experiment = self.experiment.toUpperCase() + " - " + self.equipment_id;
      }
    }
    //self.form.school = self.school_id;
    self.getSchool();
    self.getBookSlotsBySchool();
    self.getSlotsByDate();
    self.checkAuthorized();
    self.getSchoolOpenedExperiment();
    self.getExperimentSetStatus();
    self.getUserUserGroupProfile();
    console.log(self.api);
  },
  methods: {
    tableHeader(label){
      var self = this;
      if(label=='slots'){
        if(self.authorized == true) {
          if(self.$i18n.locale=='tc') return self.headers_auth_chi;
          else return self.headers_auth;
        }
        else {
          if(self.$i18n.locale=='tc') return self.headers_chi;
          else return self.headers;
        }
      }
      if(label=='daily_slots'){
        if(self.$i18n.locale=='tc') return self.headers_daily_chi;
        else return self.headers_daily;
      }
    },
    checkAuthorized: function(){
      var self = this;
      let user_level = self.$store.state.user.user_level;
      let user_school = self.$store.state.user.school_id;
      if(  ( (user_level=="INCHARGE") && user_school==self.school_id ) ||  user_level=="ADMIN" ){
        self.authorized = true;
      }
      else {
        self.authorized = false;
      }
    },
    getSlotsByDate: function () {
      var self = this;
      console.log("getSlotsByDate: " + self.current_date);
      self.api.slots = [];
      apiBooking
        .getSlotsByDate(self.current_date, self.school_id, self.experiment, self.equipment_id)
        .then((response) => {

          if (typeof response.slots != "undefined") {
            for (var slot of response.slots) {
              /*if (moment(slot.end_at) < moment()) {
                slot.display = false;
              } else {
                slot.display = true;
              }
              */              
              slot.display = true;
            }
            self.api.slots = response.slots;
          } else {
            self.api.slots = [];
          }

        });
    },
    getSchool(){
      var self = this;
      apiBooking.getSchool(self.school_id)
      .then((response) => {
          self.api.school_id = response.school;
          self.api.school_name = response.school_name;
          self.api.school_chi_name = response.school_chi_name;
          if(JSON.parse(response.school_logo)!=null){
            self.api.school_logo_url = JSON.parse(response.school_logo).url;
          }
          else {
            self.api.school_logo_url = "";
          }
          self.$emit("info", {school_id: self.api.school_id, school_name: self.api.school_name, school_chi_name: self.api.school_chi_name, school_logo_url: self.api.school_logo_url});
      });
    },
    getSchoolOpenedExperiment(){
      var self = this;
      apiManagement.getSchoolOpenedExperiment(self.school_id, self.show_all)
      .then((response) => {
          self.api.experiments = response.experiments;
      });
    },
    getExperimentList(){
      var self = this;
      apiBooking.getExperimentList()
      .then((response) => {
          self.api.experiments_list = response.experiments;
      });
    },
    getBookSlotsBySchool(){
      var self = this;
      apiManagement.getBookSlotsBySchool(self.school_id)
      .then((response) => {
          self.api.book_slots = response.book_slots;
      });
    },    
    getExperimentSetStatus(){
      var self = this;
      apiBooking.getExperimentSetStatus(self.school_id, self.experiment, self.equipment_id)
      .then((response) => {
          self.api.eStatus = response.eStatus;
      });
    },
    viewBookSlots(item){
      var self = this;
      self.$cookies.set('experiment', item.experiment);
      self.equipment_id = self.$cookies.set('equipment_id', item.equipment_id);
      self.$router.push("/school/history/"+self.school_id+"/"+item.experiment+"/"+item.equipment_id);
    },
    updateAddEquipment(){
      var self = this;
      apiBooking.getLastEquipment(self.school_id,self.form.experiment)
      .then((response) => {
        self.form.next = response.next;
      });
    },
    addSchoolExperiment(){
      var self = this;
      apiBooking.addSchoolExperiment(self.school_id,self.form.experiment,self.form.next)
      .then((response) => {
        if(response.status == "success"){
          self.$store.commit("showSnackBar", "Added New Experiment");
          self.dialog = !self.dialog;
          self.getSchoolOpenedExperiment();
        }
        else {
          alert(response.message);
        }
      });
    },
    changeExperimentSet(experiment_set){
      var self = this;
      let split = experiment_set.split(" - ");
      self.experiment = split[0];
      self.equipment_id = split[1];
      self.goTo(self.school_id, self.experiment, self.equipment_id);
//      location.reload();
      self.getSlotsByDate();
      self.getExperimentSetStatus();
    },
    getUserUserGroupProfile(){
      var self = this;
      apiBooking.getUserUserGroupProfile(self.current.username, self.school_id)
      .then((response) => {
        self.user_group_profile = response.profile;
        self.max_text = response.max_text;
        self.max_text_chi = response.max_text_chi;
      });
    },
    back(){
      var self = this;
      self.$cookies.remove("experiment");
      self.$cookies.remove("equipment_id");
      if(self.$route.name == 'admin-school-management'){
        self.$router.push("/admin/management/school/school_list");
      }
      else {
        self.$router.push("/school/school_list");
      }
    },
    goTo(item){
      var self = this;
      alert(item.school);
    },
    tmp(a){
      var self = this;
      let d = self.school_id;
      let b = self.experiment;
      let c = self.equipment_id;
      console.log(this.$store.state.user);
    },
    isPassed(slot){
      if (slot.passed) {
        return true;
      } 
      else {
        return false;
      }
    },
    isOverrided(slot){
      if ((slot.eStatus=="HOLD" && !slot.passed ) || ((slot.status=='MAINTENANCE' || slot.status=='SUSPENDED') && slot.username == this.$cookies.get("username") ) ) {
        return true;
      } 
      else {
        return false;
      }
    },
    isBookedSoon: function (slot) {
      if ( slot.current==false && ( slot.status == "RESERVED" || slot.status == "SUSPENDED" || slot.status == "MAINTENANCE" ) && slot.username == this.$cookies.get("username") ) {
        return true;
      }
      else {
        return false;
      }
    },    
    isMyBooking(slot){
      if ( (slot.status == "RESERVED"||slot.status == "SUSPENDED") && (slot.username == this.$cookies.get("username")) ) {
        return true;
      }
      else {
        return false;
      }
    },
    isBookedByMe: function (slot) {
      if ( (slot.current==true && (slot.status == "RESERVED"||slot.status == "SUSPENDED") && (slot.username == this.$cookies.get("username"))) ) {
        return true;
      }
      else {
        return false;
      }
    },
    bookSlot: function (slot_id) {
      var self = this;
      
      self.$ga.event("Booking", "book", self.$route.params.experiment_name);
      apiBooking
        .bookSlot(slot_id, self.$cookies.get("auth_token"), self.$cookies.get("username"))
        .then((response) => {
          if(response.status == "fail"){
            if (self.$i18n.locale=='tc') {
              self.$store.commit("showSnackBar", response.message_chi);
            } else {
              self.$store.commit("showSnackBar", response.message);
            }
          }
          else {
            if (self.$i18n.locale=='tc') {
              self.$store.commit("showSnackBar", "預約成功");
            } else {
              self.$store.commit("showSnackBar", "Book Success");
            }
          }
          self.getSlotsByDate();
          self.getExperimentSetStatus();
          self.$parent.getMyFutureBooking(self.current.username, self.current.school_id);
        });
    },
    enterLab: function (slot_id, experiment, equipment_id, role, override, user_level) {
      var self = this;
      if(override == "1" && role == "player"){
        self.$store.commit("showSnackBar", "This Booking is overriding by incharge/admin, please try entering later.");        
      }
      else {
        apiBooking
          .enterLab(slot_id, self.$cookies.get("username"), self.school_id, experiment, equipment_id, self.$cookies.get("auth_token"), role, user_level)
          .then((response) => {
            if (response.status == "fail") {
              if(self.$i18n.locale=='tc')
                self.$store.commit("showSnackBar", response.message_chi);
              else 
                self.$store.commit("showSnackBar", response.message);
              self.getSlotsByDate();
              self.getExperimentSetStatus();
              self.$parent.getMyFutureBooking(self.current.username, self.current.school_id);
            } else {
              if(self.$i18n.locale=='tc')
                self.$store.commit("showSnackBar", "準備中...");
              else
                self.$store.commit("showSnackBar", "Preparing...");
              
              self.$cookies.set("session_token", response.session_token);
              self.$cookies.set("role", role);
              var kick_timestamp = response.end_at;
              self.$cookies.set(
                "kick_timestamp",
                kick_timestamp,
                Math.ceil(
                  (parseInt(kick_timestamp) * 1000 - new Date().getTime()) / 1000
                )
              );
              self.$cookies.set("school_id", self.school_id);
              self.$cookies.set("experiment", experiment);
              self.$cookies.set("equipment_id", equipment_id);
              self.$cookies.set("end_at", response.end_at);
              self.$cookies.set("booking_id", slot_id);
              self.$router.push(
                "/iot_experiment/" + self.school_id + "/" + experiment.toLowerCase() + "/" + equipment_id
              );
            }
          });
      }
    },
    releaseSlot: function (slot_id) {
      var self = this;
      apiBooking
        .releaseSlot(slot_id, self.$cookies.get("auth_token"))
        .then((response) => {
          
          if(response.status == "success"){
            if (self.$i18n.locale=='tc') {
              self.$store.commit("showSnackBar", "預約已取消");
            } else {
              self.$store.commit("showSnackBar", "Booking Cancelled");
            }
          }
          else {
            if (self.$i18n.locale=='tc') {
              self.$store.commit("showSnackBar", response.message_chi);
            } else {
              self.$store.commit("showSnackBar", response.message);
            }
          }

          self.getSlotsByDate();
          self.getExperimentSetStatus();
          self.$parent.getMyFutureBooking(self.current.username, self.current.school_id);
        });
    },
    lockBooking(item) {
      var self = this;
      apiManagement
        .lockBooking(self.school_id, item.id)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.lockBookingDialog = false;
            self.lockUnlockBookingItem= {}
            self.getSlotsByDate();
            self.getExperimentSetStatus();
            self.$parent.getMyFutureBooking(self.current.username, self.current.school_id);
          } else {
            alert(response.message);
            
          }
        });
    },
    unlockBooking(item) {
      var self = this;
      apiManagement
        .unlockBooking(self.school_id, item.id)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.unlockBookingDialog = false;
            self.lockUnlockBookingItem= {}
            self.getSlotsByDate();
            self.getExperimentSetStatus();
            self.$parent.getMyFutureBooking(self.current.username, self.current.school_id);
          } else {
            alert(response.message);
            
          }
        });
    },
    setMaintenanceBooking(item) {
      var self = this;
      apiManagement
        .setMaintenanceBooking(self.school_id, item.id)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.maintenanceDialog = false;
            self.maintenanceItem= {}
            self.getSlotsByDate();
            self.getExperimentSetStatus();
            self.$parent.getMyFutureBooking(self.current.username, self.current.school_id);
          } else {
            alert(response.message);
            
          }
        });
    },
    unsetMaintenanceBooking(item) {
      var self = this;
      apiManagement
        .unsetMaintenanceBooking(self.school_id, item.id)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.unsetMaintenanceDialog = false;
            self.maintenanceItem= {}
            self.getSlotsByDate();
            self.getExperimentSetStatus();
            self.$parent.getMyFutureBooking(self.current.username, self.current.school_id);
          } else {
            alert(response.message);
          }
        });
    },
    cancelBooking(item) {
      var self = this;
      apiManagement
        .cancelBooking(self.school_id, item.id)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.cancelBookingDialog = false;
            self.cancelBookingItem= {}
            self.getSlotsByDate();
            self.getExperimentSetStatus();
            self.$parent.getMyFutureBooking(self.current.username, self.current.school_id);
          } else {
            alert(response.message);
          }
        });
    },
    undoCancelBooking(item) {
      var self = this;
      apiManagement
        .undoCancelBooking(self.school_id, item.id)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.getSlotsByDate();
            self.getExperimentSetStatus();
            self.$parent.getMyFutureBooking(self.current.username, self.current.school_id);
          } else {
            alert(response.message);
          }
        });
    },    
    returnBooking(item) {
      var self = this;
      apiManagement
        .returnBooking(self.school_id, item.username, item.id)
        .then((response) => {
          if (response.status == "success") {
            alert("success");
            self.returnBookingDialog = false;
            self.returnBookingItem= {};
            self.getSlotsByDate();
            self.getExperimentSetStatus();
            self.$parent.getMyFutureBooking(self.current.username, self.current.school_id);
            if(self.dailyBookingDialog == true){
              self.openDailyBookingDialog(self.dailyUser);
            }
          } else {
            alert(response.message);
          }
        });
    },
    openLockDialog(item){
      var self = this;
      self.lockDialog = true;
      self.lockUnlockItem = item;
      self.holdCheckbox = true;
    },
    openUnlockDialog(item){
      var self = this;
      self.unlockDialog = true;
      self.lockUnlockItem = item;
    },
    openLockBookingDialog(item){
      var self = this;
      self.lockBookingDialog = true;
      self.lockUnlockBookingItem = item;
    },
    openUnlockBookingDialog(item){
      var self = this;
      self.unlockBookingDialog = true;
      self.lockUnlockBookingItem = item;
    },
    openMaintenanceDialog(item){
      var self = this;
      self.maintenanceDialog = true;
      self.maintenanceItem = item;
    },
    openUnsetMaintenanceDialog(item){
      var self = this;
      self.unsetMaintenanceDialog = true;
      self.maintenanceItem = item;
    },
    openCancelBookingDialog(item){
      var self = this;
      self.cancelBookingDialog = true;
      self.cancelBookingItem = item;
    },
    openUndoCancelBookingDialog(item){
      var self = this;
      self.undoCancelBookingDialog = true;
      self.cancelBookingItem = item;
    },
    openDailyBookingDialog(username){
      var self = this;
      self.dailyBookingDialog = true;
      self.dailyUser = username;
      apiManagement
        .getUserDailyBookingByExperiment(self.school_id, username, self.experiment, self.equipment_id, self.current_date)
        .then((response) => {
          if (response.status == "success") {
            self.api.daily_slots = response.daily_slots;
            console.log(self.api.daily_slots)
          } else {
            alert(response.message);
          }
        });
    },    
    openReturnBookingDialog(item){
      var self = this;
      self.returnBookingDialog = true;
      self.returnBookingItem = item;
    },
    goTo: function (school, experiment, equipment_id) {
      var self = this;
      self.$router.push("/booking/"+school+"?experiment="+experiment.toLowerCase()+"&equipment="+equipment_id);
    },
    selectExperiment(){
      var self = this;
      if(self.selected_experiment==null || self.selected_experiment=="" || self.selected_experiment==undefined){
        return true;
      }
    },
  },  
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
.passed{
  color: #bbb !important;
  font-weight: lighter;
}
/*
.override{
  background: #ffe7e7;
}
.override:hover{
  background: #ffc9c9 !important;
}
*/

.my_booking:not(.passed){
  background: #daffe0;
}
.my_booking:not(.passed):hover{
  background: #c8ffd2 !important;
}
.my_booking.passed{
  background: #f2fff1;
}
.my_booking.passed:hover {
  background: #dfffdd !important;
}
.select_experiment fieldset {
    color: #ff9c9c !important;
    border-width: 2px;
}
</style>